require('bootstrap');
require('bootstrap-select');
require('fullpage.js');
require('slick-carousel');
require('select2');
require('jquery-form-styler');
require('jquery-circle-progress');
require("jquery-mousewheel");
require('malihu-custom-scrollbar-plugin');
import WOW from 'wow.js';
import 'jquery-ui-dist/jquery-ui.js'

$(function () {
    $(".loader").delay(400).fadeOut("slow");
    new WOW().init();

    (function setScrollbars() {
        const selectors = ['#main-page .text', '.not-wrap', '#main-page .team-block .text-content', '#main-page .services-block .text-content', '.risk-countries-scroll'];

        // if ($(window).outerWidth() > 991) {
            selectors.forEach(selector => {
                $(selector).mCustomScrollbar({
                    theme: "dark"
                });
            });
        // }
    }());

    function jumpToElement(element, offset) {
        if (!offset) offset = 0;
        let verticalPos = element.offset().top;
        window.scrollTo(0, verticalPos + offset);
    }
    function jumpToHash(offset) {
        let hash = window.location.hash;
        // Do nothing if no hash exists
        if (typeof hash !== 'string' || !hash.length) return;
        let targetElement = $(hash);
        // Do nothing if targetElement doesn't exist
        if (!targetElement) return;
        jumpToElement(targetElement, offset);
    }
    jumpToHash(-110);

    //background header on scroll
    $(window).scroll(function() {
        if ($(this).scrollTop() > 50){
            $('.header').addClass("header scrolling");
        } else{
            $('.header').removeClass("scrolling");
        }
    });

    $('.slider').slick({
        dots: true,
        fade: true,
        cssEase: 'linear',
        speed: 600,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 5000,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    fade: false,

                }
            }
        ]
    });

    $('.user-position-slider').slick({
        dots: false,
        fade: false,
        speed: 600,
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        variableWidth: true,
        prevArrow: '',
        nextArrow: '<span class="slick-next"></span>',
        autoplay: false,
        responsive: [
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1,
                }
            }
        ]
    });

    $('.nav-tabs .slick-slide').click(function() {
        $('.inner-item').removeClass('active show');

        $('.tab-pane').removeClass('active show');
    });

    $(".text-scroll-light").mCustomScrollbar({
        theme:"light-2"
    });

    //Show and hide password value
    $('.view-pass').click(function () {
        if ($(this).hasClass('active')) {
            $('#current_password').attr('type', 'text');
            $(this).removeClass('active');
        } else {
            $('#current_password').attr('type', 'password');
            $(this).addClass('active');
        }
    });

    // open-close popup on map
    $('.open-info').click(function () {
        $(this).closest('.map-info').addClass('active');
    });
    $('.close-info').click(function () {
        $(this).closest('.map-info').removeClass('active');
    });

    (function() {
        const height = $('.header').outerHeight();
        $('.banner').css("padding-top", height);
    }());

    (function() {
        $('a[href^=\\#], *[data-href^=\\#]').on('click', function(e){
            e.preventDefault();

            let t = 3000;
            let d = $(this).attr('data-href') ? $(this).attr('data-href') : $(this).attr('href');

            if (d !== '#'){
                $('body').stop().animate({ scrollTop: $(d).offset().top - 200 }, t);
            }
        });
    })();

    const removeOverlay = () => {
        $('#headerNavMenu').removeClass('show');
        $('.overlay').removeClass('show');
        $('body').removeClass('no-scroll');
        $('html').removeClass('no-scroll');
    }

    const resetAnimation = (selector, animation) => {
        $(selector).removeClass(animation);
        $(selector).attr('style', '');

        setTimeout(() => {
            $(selector).addClass(animation);
        }, 500)
    }

    const resetServiceAnimation = () => {
        const ANIMATION_SELECTORS = [
            {
                selector: '#homeServiceTitle',
                animation: 'wow fadeInDown'
            },
            {
                selector: '#homeServiceSubtitle',
                animation: 'wow fadeInUp'
            },
            {
                selector: '#homeServiceTab',
                animation: 'wow zoomIn'
            },
        ];

        ANIMATION_SELECTORS.forEach(el => {
            resetAnimation(el.selector, el.animation)
        })
    }

    const resetAboutAnimation = () => {
        const ANIMATION_SELECTORS = [
            {
                selector: '#homeAboutTitle',
                animation: 'wow fadeInDown'
            },
            {
                selector: '#homeAboutSubtitle',
                animation: 'wow fadeInLeft'
            },
            {
                selector: '#homeAboutDescription',
                animation: 'wow fadeInUp'
            },
        ];

        ANIMATION_SELECTORS.forEach(el => {
            resetAnimation(el.selector, el.animation)
        })
    }

    const resetTeamAnimation = () => {
        const ANIMATION_SELECTORS = [
            {
                selector: '#homeTeamTitle',
                animation: 'wow fadeInDown'
            },
            {
                selector: '#homeTeamSubtitle',
                animation: 'wow fadeInUp'
            },
            {
                selector: '#homeTeamTabTitle',
                animation: 'wow zoomIn'
            },
            {
                selector: '#homeTeamTabContent',
                animation: 'wow fadeInUp'
            },
        ];

        ANIMATION_SELECTORS.forEach(el => {
            resetAnimation(el.selector, el.animation)
        })
    }

    (function mobileBtn() {
        const mobileBtnOpen = $('.open-nav-btn');
        const mobileBtnClose = $('.close-nav-btn');
        const mobileMenu = $('.nav-holder');

        mobileBtnOpen.on('click', function() {
            mobileMenu.addClass('show');

            $('.overlay').addClass('show');
            $('body').addClass('no-scroll');
            $('html').addClass('no-scroll');
        });

        mobileBtnClose.on('click', function(){
            removeOverlay();
        });
    }());

    (function scrollIntoServices() {
        $('#homeLinksTabs').on('click', (e) => {
            let TAB = +($(e.target).attr('data-nav-tabs'));

            $(`.nav-tabs .item:nth-of-type(${TAB+1}) a`).tab('show');
            document.getElementById("services").scrollIntoView();

            resetServiceAnimation();
        })
    }());

    (function scrollFromTheMenu() {
        const MENUS = [
            {
                btn: '#scroll-about',
                block: 'about'
            },
            {
                btn: '#scroll-service',
                block: 'services'
            },
            {
                btn: '#scroll-team',
                block: 'team'
            }
        ]

        MENUS.forEach(menu => {
            $(menu.btn).on('click touch', () => {
                document.getElementById(menu.block).scrollIntoView();
                removeOverlay();

                if (menu.block === 'about') {
                    resetAboutAnimation();
                }

                if (menu.block === 'services') {
                    resetServiceAnimation();
                }

                if (menu.block === 'team') {
                    resetTeamAnimation();
                }
            })
        })
    }())
});

$(window).on('load', () => {
    if (window.location.search && window.location.search.includes('?color_code=')) {
        const SEARCH = window.location.search.replace('?color_code=', '')

        $(`#collapse-${SEARCH}`).collapse();
    }
})





